import IStampOutput from "@/api/models/IStampOutput";

export default (stamp: IStampOutput) => {
  const d = new FormData();
  d.append("id", String(stamp.id));
  d.append("width", String(stamp.width));
  d.append("icon", stamp.icon);
  if (stamp.image) {
    d.append("image", stamp.image);
  }
  d.append("height", String(stamp.height));
  d.append("top", String(stamp.top));
  d.append("left", String(stamp.left));
  d.append("officeId", String(stamp.officeId));

  return d;
};
